import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { APP_ROUTES } from '../../../core/constants/app-route.constants';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent {
  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  goLogin() {
    this.router.navigateByUrl(APP_ROUTES.AUTH.LOGIN);
  }
}
